import AnalyticsEngineXiTiBase from "./../../../../src/common/analytics/engines/analyticsEngineXiTiBase";
import { stripHtml } from "./../../../../src/common/utilities/utils";
const moment = require("moment");

export default class AnalyticsCustomEngineXiTi extends AnalyticsEngineXiTiBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
  }

  getPageLabel(data = null, page = null) {
    const label = this._getPageStructure(data, page);
    return label;
  }

  getArticleLabel(data = null, page = null) {
    const label = this._getArticleStructure(data, page);
    return label;
  }

  _getArticleStructure(data, page) {
    let regionCode = "";
    let date = "";
    const articles = page.articles;
    const category = page.section;
    const downloadToken = data.downloadToken;
    if (downloadToken) {
      regionCode = downloadToken.slice(-2);
      date = moment(data.bundleDateTime).format("DD-MM-YYYY");
    }
    const title = `${stripHtml(articles[0].title)}_${regionCode}_${date}`;
    const label = {
      chapter1: "webapp",
      chapter2: category,
      chapter3: "lightbox",
      name: title,
      level2: "82",
      customObject: {
        device: window.innerWidth >= 980 ? "desktop" : "smartphone",
      },
    };
    return label;
  }

  _getPageStructure(data, page) {
    let regionCode = "";
    let date = "";
    const category = page.section;
    const pageNumber = page.pagePosition;
    const pageReference = page.pageReference;
    const downloadToken = data.downloadToken;
    if (downloadToken) {
      regionCode = downloadToken.slice(-2);
      date = moment(data.bundleDateTime).format("DD-MM-YYYY");
    }
    const ref = `${pageReference || pageNumber}_${regionCode}_${date}`;
    const label = {
      chapter1: "webapp",
      chapter2: category,
      chapter3: `PDF`,
      name: ref,
      level2: "82",
      customObject: {
        device: window.innerWidth >= 980 ? "desktop" : "smartphone",
      },
    };
    return label;
  }

  _isDesktop() {
    const viewPortWitdh = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    const isDesktop = viewPortWitdh >= 768;
    return isDesktop;
  }
}



// WEBPACK FOOTER //
// ./clients/tel-tel/js/engines/analyticsEngineXiTi.js